(function () {
  var EXCLUDE_CLASS = [
    'slider__buttons',
    'content-item--heading',
    'field__input',
    'disclosure-selector',
    'facet-remove',
    'active-facets__button-wrapper',
    'sort-selector',
    'mobile-facets__container',
    'mobile-facets__button',
    'collection--empty',
    'bnexo-404__card',
    'pagination__container'
  ];

  var EXCLUDE_ANCESTOR = [
    '.header',
    '.footer',
    'cart-drawer',
    '.cart-notification',
    '.predictive-search',
    '.promotion-popup',
    '.age-verification-popup',
    '.pickup-availability',
    '.documentation'
  ];

  function isExcluded(el) {
    if (EXCLUDE_CLASS.some(function (c) { return el.classList.contains(c); })) {
      return true;
    }
    return EXCLUDE_ANCESTOR.some(function (sel) { return el.closest(sel); });
  }

  function shouldHaveNeon(el) {
    if (el.classList.contains('product-card')) {
      return !el.querySelector(':scope > .bnexo-neon-ring');
    }
    if (!el.classList.contains('content-item') && !el.classList.contains('collection-list')) {
      return false;
    }
    if (el.querySelector('.product-card')) {
      return false;
    }
    if (el.querySelector(':scope > .bnexo-neon-ring')) {
      return false;
    }
    if (isExcluded(el)) {
      return false;
    }
    if (el.classList.contains('collection-list')) {
      return true;
    }
    if (el.classList.contains('content__shadow--h')) {
      return true;
    }
    if (el.classList.contains('hover-area')) {
      return true;
    }
    return false;
  }

  function injectRing(el) {
    if (!shouldHaveNeon(el)) {
      return;
    }
    var ring = document.createElement('span');
    ring.className = 'bnexo-neon-ring';
    ring.setAttribute('aria-hidden', 'true');
    el.insertBefore(ring, el.firstChild);
    el.classList.add('bnexo-neon-card');
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    root.querySelectorAll('.content-item, a.collection-list, .product-card').forEach(injectRing);
  }

  function applyPorteColors() {
    var porteColors = ['#FF6B35', '#00D4FF', '#00FF88'];
    document.querySelectorAll('[data-section-name="text-columns-with-images"]').forEach(function (section) {
      var headings = section.querySelectorAll('.text-columns-img__heading');
      if (headings.length !== 3) {
        return;
      }
      var firstHeading = headings[0] ? headings[0].textContent : '';
      if (firstHeading.indexOf('予約') === -1) {
        return;
      }
      section.querySelectorAll('.content-item').forEach(function (item, index) {
        if (index >= porteColors.length) {
          return;
        }
        var color = porteColors[index];
        item.classList.add('bnexo-porte');
        item.style.setProperty('--bnexo-porte-color', color);
        item.style.setProperty('--bnexo-neon', color);
        item.style.setProperty('--bnexo-neon-bright', color);
        item.style.setProperty('--bnexo-neon-dim', color);
        item.style.setProperty('--bnexo-neon-glow', color + '8c');
        item.style.setProperty('--bnexo-neon-glow-strong', color + 'd9');
        var title = item.querySelector('.text-columns-img__heading');
        if (title) {
          title.classList.add('bnexo-porte-heading');
        }
      });
      section.classList.add('bnexo-portes-section');
    });
  }

  function init() {
    scan(document);
    applyPorteColors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    applyPorteColors();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('.content-item, a.collection-list');
    if (item) {
      injectRing(item);
    }
  });

  if (typeof MutationObserver !== 'undefined' && document.body) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }
          if (node.matches && (node.matches('.content-item, a.collection-list') || node.matches('.product-card'))) {
            injectRing(node);
          }
          scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
